var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}},[_c('path',{attrs:{"d":"M16 10h-6v6H8v-6H2V8h6V2h2v6h6v2Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }